import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { verifyOtp } from '../../API/functions';



export const useVerifyOtp = ({onSuccess}) => {
  const { mutate,isPending } = useMutation({
    mutationFn: (vars) => verifyOtp(vars),
    onSuccess: (data) => {
      toast.success(data.message);
      if (onSuccess) onSuccess(data); 
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || "Something went wrong!";
      toast.error(errorMessage);
    },
  });
  return { mutate ,isPending};
};
